import React from "react";
import {
  PayPalScriptProvider,
  PayPalButtons,
  PayPalMessages,
} from "@paypal/react-paypal-js";

const REACT_APP_URL = process.env.REACT_APP_URL;
const REACT_APP_PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
const REACT_APP_PAYPAL_PAYLATER_CLIENT_ID = process.env.REACT_APP_PAYPAL_PAYLATER_CLIENT_ID;

function PayPalCheckout({
  plan_id,
  payment_id,
  currency,
  setError,
  setSuccess,
  submit,
  order,
  payment,
  browserInfo,
  ipAddress,
  isFullpayment,
  isSelfCheckout,
  selfCheckoutDetails,
}) {
//   // Don't render if required values are missing
//   const requiredClientId = isFullpayment ? REACT_APP_PAYPAL_PAYLATER_CLIENT_ID : REACT_APP_PAYPAL_CLIENT_ID;
//   if (!currency || !requiredClientId) {
//     console.log("PayPalCheckout: Missing required values", {
//       currency,
//       isFullpayment,
//       hasClientId: !!REACT_APP_PAYPAL_CLIENT_ID,
//       hasPayLaterClientId: !!REACT_APP_PAYPAL_PAYLATER_CLIENT_ID,
//       REACT_APP_PAYPAL_CLIENT_ID:REACT_APP_PAYPAL_CLIENT_ID
//     });
//     return null;
//   }

  const initialOptions = {
    "client-id": REACT_APP_PAYPAL_CLIENT_ID,
    intent: plan_id ? "subscription" : "capture",
    vault: plan_id ? true : false,
    currency: currency,
  };

  const payLaterOption = {
    "client-id": REACT_APP_PAYPAL_PAYLATER_CLIENT_ID,
    components: ["messages", "buttons"],
    "enable-funding": "paylater",
    intent: "capture",
    vault: false,
    currency: currency,
  };

  const userConsent = async () => {
    try {
      const countryId = isSelfCheckout
        ? selfCheckoutDetails?.currencyId
        : order?.[0]?.countryId;
      const masterOrderId = payment?.orderId;
      const paymentId = payment?.paymentId;

      const response = await fetch(`${REACT_APP_URL}/userConsent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          countryId,
          masterOrderId,
          paymentId,
          ipAddress,
          ...browserInfo,
        }),
      });
      if (!response.ok) {
        throw new Error("Unable to get user consent details.");
      }
      await response.json();
    } catch (err) {
      console.log("error while getting user info: ", err);
    }
  };

  const isValid = () => {
    if (
      (order && order?.[0] && order?.[0]?.countryId === 2) ||
      (selfCheckoutDetails && selfCheckoutDetails?.countryId === 2)
    ) {
      return true;
    } else {
      return false;
    }
  };

  return isFullpayment ? (
    <PayPalScriptProvider options={payLaterOption}>
      {isValid() && (
        <PayPalMessages
          style={{ layout: "text" }}
          amount={payment?.amount}
          buyerCountry={"US"} // paylater is available in US
        />
      )}
      <PayPalButtons
        createOrder={async (data, actions) => {
          await userConsent();
          const orderData = await actions.order.create({
            application_context: {
              return_url: `${window.location.href}`,
              cancel_url: `${window.location.href}`,
              brand_name: "Codeyoung",
              locale: "en-US",
              shipping_preference: "NO_SHIPPING",
            },
            purchase_units: [
              {
                custom_id: payment_id,
                description: "Registration Amount",
                amount: {
                  currency_code: `${currency}`,
                  value: `${payment?.amount}`,
                },
              },
            ],
          });
          return orderData;
        }}
        // Call your server to finalize the transaction
        onApprove={async (data, actions) => {
          const orderData = await actions?.order?.capture();

          // Three cases to handle:
          //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
          //   (2) Other non-recoverable errors -> Show a failure message
          //   (3) Successful transaction -> Show confirmation or thank you

          var errorDetail =
            Array.isArray(orderData?.details) && orderData?.details?.[0];
          if (errorDetail && errorDetail?.issue === "INSTRUMENT_DECLINED") {
            return actions?.restart();
          }

          if (errorDetail) {
            var msg = "Sorry, your transaction could not be processed.";
            if (errorDetail?.description)
              msg += "\n\n" + errorDetail?.description;
            if (orderData?.debug_id) msg += " (" + orderData?.debug_id + ")";
            console.error(msg);
            setError(true);
          }

          setSuccess(true);
        }}
        onError={(err) => {
          console.log("err", err);
          setError(true);
        }}
      />
    </PayPalScriptProvider>
  ) : (
    <PayPalScriptProvider options={initialOptions}>
      {plan_id ? (
        <PayPalButtons
          createSubscription={async (data, actions, err) => {
            await userConsent();
            const orderId = await actions.subscription.create({
              plan_id: plan_id, // Creates the subscription
            });
            return orderId;
          }}
          disabled={!submit}
          style={{
            label: "subscribe",
          }}
          onApprove={(data, actions) => {
            alert(
              "You have successfully created subscription " +
                data?.subscriptionID
            ); // Optional message given to subscriber
            setSuccess(true);
          }}
          onError={(err) => {
            console.log("err", err);
            setError(true);
          }}
        />
      ) : (
        <PayPalButtons
          // Call your server to set up the transaction
          createOrder={async (data, actions) => {
            await userConsent();
            const orderData = await actions.order.create({
              application_context: {
                return_url: `${window.location.href}`,
                cancel_url: `${window.location.href}`,
                brand_name: "Codeyoung",
                locale: "en-US",
                shipping_preference: "NO_SHIPPING",
              },
              purchase_units: [
                {
                  custom_id: payment_id,
                  description: "Registration Amount",
                  amount: {
                    currency_code: `${currency}`,
                    value: `${payment?.amount}`,
                  },
                },
              ],
            });
            return orderData;
          }}
          disabled={!submit}
          // Call your server to finalize the transaction
          onApprove={async (data, actions) => {
            const orderData = await actions?.order?.capture();

            // Three cases to handle:
            //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            //   (2) Other non-recoverable errors -> Show a failure message
            //   (3) Successful transaction -> Show confirmation or thank you

            var errorDetail =
              Array.isArray(orderData?.details) && orderData?.details?.[0];
            if (errorDetail && errorDetail?.issue === "INSTRUMENT_DECLINED") {
              return actions?.restart();
            }

            if (errorDetail) {
              var msg = "Sorry, your transaction could not be processed.";
              if (errorDetail?.description)
                msg += "\n\n" + errorDetail?.description;
              if (orderData?.debug_id) msg += " (" + orderData?.debug_id + ")";
              console.error(msg);
              setError(true);
            }

            setSuccess(true);
          }}
          onError={(err) => {
            console.log("err", err);
            setError(true);
          }}
        />
      )}
    </PayPalScriptProvider>
  );
}

export default PayPalCheckout;
